import { ReusableFunctions } from './reusable-functions';

export class IncentivesProfitabilityChartOptions {
    constructor(private reusableFunctions: ReusableFunctions) {}

    public createProfitabilityScatterPlot(
        title: string,
        xAxisText: string,
        yAxisText: string,
        seriesData: any[],
        seriesColor: string,
        dataLabelsEnabled: boolean,
        clickHandler: any,
        isLoan: boolean,
        context: any = null
    ): Highcharts.Options {
        const _this = this;

        return {
            chart: {
                spacingBottom: 0,
                spacingLeft: 0,
                marginRight: 0,
                spacingRight: 0,
                spacingTop: 0,
                type: 'scatter',
                zooming: {
                    type: 'xy',
                },
                height: 700,
                events: {
                    render() {
                        if (context.links.length > 0) {
                            let chart = this,
                                x = this.chartWidth - 36,
                                y = 0;

                            if (chart['goBackBtn']) {
                                chart['goBackBtn'].destroy();
                            }

                            chart['goBackBtn'] = chart.renderer
                                .label('Back', x, y)
                                .attr({
                                    zIndex: 4,
                                })
                                .css({
                                    color: '#0078D7',
                                    cursor: 'pointer',
                                })
                                .on('click', context.goBack())
                                .add();

                            //center button after render with width value
                            chart['goBackBtn'].translate(
                                chart['goBackBtn'].x - chart['goBackBtn'].width / 2,
                                chart['goBackBtn'].y
                            );
                        }
                    },
                },
            },
            title: {
                text: title,
                align: 'left',
                useHTML: true,
                x: 5,
            },
            credits: {
                enabled: false,
            },
            series: [
                {
                    data: seriesData,
                    turboThreshold: 0,
                    type: 'scatter',
                    color: seriesColor,
                    marker: {
                        symbol: 'circle',
                    },
                    point: {
                        events: {
                            click: clickHandler,
                        },
                    },
                },
            ],
            exporting: {
                enabled: false,
            },
            xAxis: [
                {
                    labels: {
                        enabled: true,
                        style: {
                            fontSize: '1em',
                        },
                    },
                    title: {
                        text: xAxisText,
                        style: {
                            fontSize: '1em',
                        },
                    },
                } as Highcharts.XAxisOptions,
            ],
            yAxis: [
                {
                    title: {
                        text: yAxisText,
                        style: {
                            fontSize: '1em',
                        },
                    },
                    labels: {
                        enabled: true,
                        style: {
                            fontSize: '1em',
                        },
                    },
                } as Highcharts.YAxisOptions,
            ],
            legend: {
                enabled: false,
            },
            plotOptions: {
                scatter: {
                    dataLabels: {
                        format: '{point.name}',
                        enabled: dataLabelsEnabled,
                    },
                    marker: {
                        radius: 5,
                        states: {
                            hover: {
                                enabled: true,
                                lineColor: 'rgb(100,100,100)',
                                lineWidth: 0,
                            },
                        },
                    },
                    states: {
                        hover: {},
                    },
                },
                series: {
                    maxPointWidth: 52,
                    groupPadding: 0,
                    gridLineWidth: 0,
                    minorGridLineWidth: 0,
                    pointStart: 0,
                    dataGrouping: {
                        enabled: false,
                    },
                    cursor: 'pointer',
                } as Highcharts.PlotSeriesOptions,
            },
            tooltip: {
                style: {
                    color: '#223540',
                    fontFamily: 'Roboto',
                    fontSize: '12',
                    height: 12,
                    opacity: 1,
                },
                borderColor: 'white',
                backgroundColor: 'white',
                borderRadius: 7,
                shared: true,
                useHTML: true,
                borderWidth: 1,
                formatter: function () {
                    const tooltipTitle = isLoan
                        ? `Loan # ${this.key}`
                        : this.point?.properties?.titlePart ?? '';
                    const isTitleLong = tooltipTitle.length > 17 ? true : false;
                    return `<div>
                        <div class="profitability-tooltip-title">
                            <div class="profitability-tooltip-icon">•</div>
                            ${
                                isTitleLong
                                    ? `<div style="font-size: 12px; font-weight: 700; min-width: 140px !important">${tooltipTitle}</div>`
                                    : `<div style="font-size: 12px; font-weight: 700">${tooltipTitle}</div>`
                            }
                        </div>
                      <table>
                        <tr>
                          <td>Volume: </td>
                          <td style="text-align: right;">${_this.reusableFunctions.formatMoney(
                              +this.x
                          )}</td>
                        </tr>
                        <tr>
                          <td>Profit (Loss): </td>
                          <td style="text-align: right;">${
                              this.point?.properties?.revenue ?? ''
                          }</td>
                        </tr>
                        <tr>
                          <td>BPS: </td>
                          <td style="text-align: right;">${this.point?.properties?.bps ?? ''}</td>
                        </tr>
                       </table>
                    </div>`;
                },
            } as Highcharts.TooltipOptions,
        };
    }
}
